'use client';

import type { FC } from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import { Button, Grid2 } from '@mui/material';
import { NavAboutItem } from 'layouts/Main/constants';

interface IProps {
  activeLink: string;
}

const AboutNav: FC<IProps> = ({ activeLink }) => {
  const theme = useTheme();

  return NavAboutItem.map((item, i) => (
    <Grid2 key={i} size={{ xs: 12 }}>
      <Button
        size={'large'}
        component={'a'}
        href={item.href}
        key={item.href}
        fullWidth
        sx={{
          justifyContent: 'flex-start',
          color: activeLink.includes(item.href)
            ? theme.palette.primary.main
            : theme.palette.text.primary,
          backgroundColor: activeLink.includes(item.href)
            ? alpha(theme.palette.primary.main, 0.1)
            : 'transparent',
          fontWeight: activeLink.includes(item.href) ? 600 : 400,
        }}
      >
        {item.label}
      </Button>
    </Grid2>
  ));
};

export default AboutNav;
